"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var CopyToClipboardInput_1 = require("./CopyToClipboardInput");
Object.defineProperty(exports, "default", { enumerable: true, get: function () { return CopyToClipboardInput_1.default; } });
